const getEnv = (key, defaultValue) => {
  if (typeof window !== 'undefined' && window.__ENV__ && window.__ENV__[key]) {
    return window.__ENV__[key];
  }
  return process.env[key] || defaultValue;
};

module.exports = {
  api: {
    protocol: getEnv('VUE_APP_API_PROTOCOL', 'http'),
    host: getEnv('VUE_APP_API_HOST', 'localhost'),
    port: getEnv('VUE_APP_API_PORT', '9080'),
  },
  config: {
    defaultEmail: getEnv('VUE_APP_DEFAULT_EMAIL', 'info@virtual.com'),
    publicBucketURL: getEnv('VUE_APP_PUBLIC_BUCKET_URL', 'https://d1kyukr57v0xtm.cloudfront.net'),
    preProd: getEnv('VUE_APP_PRE_PROD', 'false') === 'false',
  },
  // Tool version and build identity. vue.config.js fills both from package.json
  // / VP_BUILD_SHA for local builds; CI writes the real values into config-env.js.
  app: {
    version: getEnv('VUE_APP_APP_VERSION', 'unknown'),
    buildSha: getEnv('VUE_APP_BUILD_SHA', 'dev'),
  },
  avatar: {
    folder: getEnv('VUE_APP_AVATAR_FOLDER', 'avatar-files'),
    version: getEnv('VUE_APP_AVATAR_VERSION', 'v1'),
    buildFile: getEnv('VUE_APP_AVATAR_BUILD_FILE', 'Build.data'),
    frameworkFile: getEnv('VUE_APP_AVATAR_FRAMEWORK_FILE', 'Build.framework.js'),
    loaderFile: getEnv('VUE_APP_AVATAR_LOADER_FILE', 'Build.loader.js'),
    wasmFile: getEnv('VUE_APP_AVATAR_WASM_FILE', 'Build.wasm'),
  },
};
